// app.yourScriptName.init();
